// app.yourScriptName.init();
